import { Link } from 'gatsby';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/common/button';
import { Footer } from '../../components/common/footer';
import { Navbar } from '../../components/common/navbar';
import { SEO } from '../../components/common/seo/index';
import type { NotFoundProps } from './types';

const NotFound = ({ subtitle, title }: NotFoundProps) => {
    const { t } = useTranslation();

    return (
        <>
            <Navbar />
            <SEO />
            <div className="flex items-center justify-center">
                <div className="grid text-center w-full max-md:px-5 py-24 m-auto justify-center">
                    <div className="text-6xl font-bold text-gray-700">{title}</div>

                    <h2 className="text-2xl font-normal text-gray-600 mt-6">{subtitle}</h2>
                    <div className="grid md:flex gap-4  justify-center">
                        <Link to="/">
                            <Button className="w-full rounded-md text-lg mt-6 px-8 normal-case">{t('notFound.home', 'Home')}</Button>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="flex-shrink-0">
                <Footer />
            </div>
        </>
    );
};
export default NotFound;
